module.exports = __webpack_public_path__ + "static/img/sinqro.8a53c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sinqro.png
// module id = wkim
// module chunks = 4